import { Service } from '../Service';

namespace app.services.resources {

  export interface ITranslationParams extends IParams {
    projectId: string;
    collectionId: string;
    resourceId: string;
    sourceLanguage: string;
  }

  export class TranslationService extends Service<any> {
    constructor(resource: any, private configService, private httpService, resourceWrapperService) {
      super({resource, resourceWrapperService});

      let raw = this.resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/collection/:collectionId/resource/:resourceId/translation`,
        {projectId: "@projectId", collectionId: "@collectionId", resourceId: "@resourceId"},
        {
          update: {method: "PUT"},
          query: {method: "GET", params: {page: 1, limit: 50}, isArray: false, timeout: 120000}
        });

      this.itemResource = this.resourceWrapperService.WrapActions(raw);
    }

    public async LoadOne(params: ITranslationParams) {
      return await this.itemResource.get({
        projectId: params.projectId,
        collectionId: params.collectionId,
        resourceId: params.resourceId
      }).$promise;
    }

    public HasCache(id: string): boolean {
      return false;
    }

    public AutoTranslate(params: ITranslationParams): void {
      let url = `${this.configService.getServerBaseUrl()}/project/${params.projectId}/collection/${params.collectionId}/resource/${params.resourceId}/translate`;
      return this.httpService.$http({
        method: "PUT",
        url: url,
        data: {"sourceLanguage": params.sourceLanguage}
      });
    }
  }

  frontendApp.factory("TranslationService", ['$resource', 'ConfigService', 'HttpService', 'ResourceWrapperService', function(resource, configService, httpService, resourceWrapperService) {
    return new TranslationService(resource, configService, httpService, resourceWrapperService);
  }]);
}
